import { cn } from '@ui/lib/utils'

interface FormErrorProps extends React.HTMLAttributes<HTMLParagraphElement> {
  error?: string
}

export function FormError({ error, className, ...props }: FormErrorProps) {
  if (!error) return null

  return (
    <p className={cn('text-sm text-red-600', className)} role="alert" {...props}>
      {error}
    </p>
  )
}
